/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_SpeakersInputs */

const en_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating speakers of events... please wait...`)
};

const fr_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul des intervenants... veuillez patienter...`)
};

const de_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anzahl der Redner für die Veranstaltung wird berechnet... Bitte warten...`)
};

const it_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo dei parlanti degli eventi... attendere prego...`)
};

const ru_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расчет количества выступающих на мероприятиях... пожалуйста, подождите...`)
};

const es_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando hablantes de eventos... por favor espere...`)
};

const zh_cn2_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在计算活动发言人数……请稍候……`)
};

const ja_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのスピーカーを計算しています...お待ちください...`)
};

const hi_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम में शामिल होने वाले वक्ताओं की गणना की जा रही है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_calculating_speakers = /** @type {(inputs: Calculating_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando o número de participantes no evento... aguarde...`)
};

/**
* | output |
* | --- |
* | "Calculating speakers of events... please wait..." |
*
* @param {Calculating_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_speakers = /** @type {((inputs?: Calculating_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_calculating_speakers(inputs)
	if (locale === "de") return de_calculating_speakers(inputs)
	if (locale === "it") return it_calculating_speakers(inputs)
	if (locale === "ru") return ru_calculating_speakers(inputs)
	if (locale === "es") return es_calculating_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_calculating_speakers(inputs)
	if (locale === "ja") return ja_calculating_speakers(inputs)
	if (locale === "hi") return hi_calculating_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_calculating_speakers(inputs)
	return en_calculating_speakers(inputs)
});